<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
		<g
			fill="none"
			fill-rule="evenodd"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(2 2)"
		>
			<path
				d="m12.5 1.5c2.4138473 1.37729434 4 4.02194088 4 7 0 4.418278-3.581722 8-8 8s-8-3.581722-8-8 3.581722-8 8-8"
			></path>
			<path d="m12.5 5.5v-4h4"></path>
		</g>
	</svg>
</div>
